import { gql } from "@apollo/client";

export const ADMIN_SENTRY_SESSION_STATUS_QUERY = gql`
    query AdminSentrySessionStatus {
        adminSentrySessionStatus {
            sessionId
            hasActiveSession
            hasActiveStreamSession
            startTime
            endTime
            doubleSentry
            checkinCount
        }
    }
`;
